<template>
  <div style="min-width:120px">
    <!--select-- class="form-control select2" :value="input.value" :name="input.value" :required="input.required">
        <option :value="null">Select from options</option>
        <option v-for="option in input.options" v-bind:key="option.value" :value="option.value" :selected="input.value==option.value?'selected':''">{{option.label}}</option>
    </!--select-->
    <vSelect
      v-model="thisValue"
      :name="input.name"
      :required="input.required"
      :options="input.options"
      :model.sync="thisValue"
      :searchable="true"
      language="en-US"
      :placeholder="input.placeholder"
      :readonly="input.readonly"
      :disabled="input.disabled || input.readonly"
      @input="handleChange"
    >
    </vSelect>
  </div>
</template>
<style>
.v-select.vs--single.vs--searchable.vs--disabled .vs__dropdown-toggle {
  background: #f8f8f8 !important;
}
.v-select.vs--single.vs--searchable.vs--disabled .vs__dropdown-toggle svg {
  display: none !important;
}
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "Select",
  components: {
    vSelect,
  },
  props: {
    input: Object,
    value: [String, Number],
  },
  data: function() {
    ////console.log(this.input.options.find(item => item.value == this.value));
    return {
      thisValue: this.input.options.find(
        (item) =>
          String(item.value).toUpperCase() == String(this.value).toUpperCase()
      ),
    };
  },
  methods: {
    handleChange(e) {
      ////console.log(e);
      // this.thisValue = e.target.value;
      if (e) {
        e.target = {
          value: e.value || undefined,
          name: this.input.name,
        };
      } else {
        e = {
          target: {
            value: undefined,
            name: this.input.name,
          },
        };
      }

      if (
        e.target.value == "" ||
        e.target.value == null ||
        e.target.value == undefined
      ) {
        ////console.log('reset?');
        this.select = 0;
      }
      ////console.log(this.thisValue);
      this.$emit("handleChange", e);
    },
  },
};
</script>
